import LocalizedStrings from "react-localization";

export const languages = new LocalizedStrings({
  rs: {
    //Menu
    menuPhotos: "Fotografije",
    menuSoulApartment: "Soul apartman",
    menuContactUs: "Kontakt",

    //Photos

    photosTitle: "Fotografije",

    //Soul Apartment

    soulApartmentTitle: "Soul Apartman",

    //About
    locationTabTitle: "Lokacija",
    locationTabMainTitle: "Lokacija Soul Apartmana",
    locationTabDescription:
      "Soul apartman u ulici Birčaninova 28/b je potpuno renoviran smeštaj u srcu srpske prestonice. Na odličnoj lokaciji, svega 250m od Trga Slavija, osličan je izbor za one koji žele da obilaze Beograd. Trg Republike nalazi se na svega 15 min hoda, a linije gradskog prevoza koje se nalaze u neposrednoj blizini su - tramvaj broj 2, trolejbusi 19, 21, 22, 29 i autobus 31. Ukoliko u srpsku prestonicu dolazite avionom, sa Aerodroma 'Nikola Tesla' stižete za svega 15 minuta, a  autobuska i železnička stanica su udaljene svega 2.5km. Beograd na vodi nalazi se na manje od 2km.",
    roomTabTitle: "Soba",
    roomTabMainTitle: "Soba",
    roomTabDescriptioItemAir: "Klima",
    roomTabDescriptioItemWifi: "Besplatan wi-fi",
    kitchenTabTitle: "Kuhinja",
    kitchenTabMainTitle: "Kuhinja",
    kitchenCoffeeMachine: "Aparat za kafu",
    kitchenMicrowaveOven: "Mikrotalasna",
    kitchenDishwashingMashine: "",
    kitchenRefrigerator: "Frižider",
    kitchenKitchenSink: "Mašina za pranje sudova",
    bathroomTabTitle: "Kupatilo",
    bathroomTabMainTitle: "Kupatilo",
    bathroomShower: "Tuš",
    bathroomWashingMachine: "Mašina za veš",
    bathroomHairdryer: "Fen za kosu",
    bathroomTowels: "Peškiri",
    distanceTabTitle: "Udaljenost",
    distanceTabMainTitle: "Udaljenost",
    distancePublicTransport: "Javni prevoz - 250m",
    distanceDowntown: "Centar grada - 2km",
    distanceSlavijaSquare: "Trg Slavija - 300m",
    distanceSkadarlija: "Skadarlija - 2km",
    distanceTempleOfStSava: "Hram Svetog Save - 300m",
    distanceRepublicSquare: "Trg Republike - 2km",
    distanceNacionalAssembly: "Narodna skupština - 1.8km",
    distanceKalemegdan: "Kalemegdan - 2.5km",
    distanceBelgradeWaterfront: "Beograd na vodi - 2km",
    distanceAirportNikolaTesla: "Aerodrom Nikola Tesla - 18km",
    distanceTrainStation: "Železnička stanica - 15 min",
    distanceBusStation: "Autobuska stanica - 15 min",
    distanceFootballStadiumsRedStarAndPartizan: "Fudbalski stadioni Crvene Zvezde i Partizana - 3km",
    distanceShoppingCenterUsce: "Ušće šoping centar - 3km",

    //ContactUs
    contactUsTitle: "Kontakt",
    contactUsDescriptionFirstPart: "Kontaktirajte nas putem mail-a:",
    contactUsDescriptionSecondPart: " ili preko",
    contactUsDescriptionThirdPart: " ili nas poyovite na +381603024661."
  },
  en: {
    //Menu
    menuPhotos: "Photos",
    menuSoulApartment: "Soul Apartment",
    menuContactUs: "Contact Us",
    //Photos
    photosTitle: "Photos",

    //Soul Apartment
    soulApartmentTitle: "Soul Apartment",

    //About
    locationTabTitle: "Location",
    locationTabMainTitle: "Soul Apartment Location",
    locationTabDescription:
      "Soul Apartment in Bircaninova 28/b is a newly renovated and high standard studio apartment. Perfect location, only 250m away from Slavija Square in Belgrade, make this apartment ideal combination for great sightseeing and convenient comfort breaks. Apartment is only 15 min away from city center and you can reach it by foot go there with almost all lines - tram 2, trolley 19, 21, 22, 29 and bus 31. If you are coming in Belgrade by airplane, you will need only 15min from airplane to Soul Apartment. Central bus and railway stations are also close - less than 2.5 km away. Belgrade Waterfront is also close, only 2km away.",
    roomTabTitle: "Room",
    roomTabMainTitle: "Room",
    roomTabDescriptioItemAir: "Air-condition",
    roomTabDescriptioItemWifi: "Free wi-fi",
    kitchenTabTitle: "Kitchen",
    kitchenTabMainTitle: "Kitchen",
    kitchenCoffeeMachine: "Coffee machine",
    kitchenMicrowaveOven: "Microwave oven",
    kitchenDishwashingMashine: "Dishwashing mashine",
    kitchenRefrigerator: "Refrigerator",
    kitchenKitchenSink: "Dish washing machine",
    bathroomTabTitle: "Bathroom",
    bathroomTabMainTitle: "Bathroom",
    bathroomShower: "Shower",
    bathroomWashingMachine: "Washing machine",
    bathroomHairdryer: "Hairdryer",
    bathroomTowels: "Towels",

    distanceTabTitle: "Distance",
    distanceTabMainTitle: "Distance",
    distancePublicTransport: "PublicTransport - 350m",
    distanceDowntown: "Downtown - 2km",
    distanceSlavijaSquare: "Slavija Square - 300m",
    distanceSkadarlija: "Skadarlija - 2km",
    distanceTempleOfStSava: "Temple of St Sava - 300m",
    distanceRepublicSquare: "Republic Square - 2km",
    distanceNacionalAssembly: "Nacional Assembly - 1.8km",
    distanceKalemegdan: "Kalemegdan - 2.5km",
    distanceBelgradeWaterfront: "Belgrade Waterfront - 2km",
    distanceAirportNikolaTesla: "Airport Nikola Tesla - 18km",
    distanceTrainStation: "Train Station - 15 min",
    distanceBusStation: "Bus Station - 15 min",
    distanceFootballStadiumsRedStarAndPartizan: "Football Stadiums Red Star and Partizan - 3km",
    distanceShoppingCenterUsce: "Shopping Center Usce - 3km",

    //ContactUs
    contactUsTitle: "Contact Us",
    contactUsDescriptionFirstPart: "Contact us on email:",
    contactUsDescriptionSecondPart: " or via",
    contactUsDescriptionThirdPart: " or just call us at +381603024661."
  }
});
